import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ctaboxthree',
  templateUrl: './ctaboxthree.component.html',
  styleUrls: ['./ctaboxthree.component.scss']
})
export class CtaboxthreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
